import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface C1PageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  /** Small uppercase label above the title. */
  eyebrow?: ReactNode;
  subtitle?: ReactNode;
  /** Buttons or links aligned to the right of the title. */
  actions?: ReactNode;
}

/** Page title block — the standard opening of every console page. */
export function C1PageHeader({
  title,
  eyebrow,
  subtitle,
  actions,
  className,
  ...props
}: C1PageHeaderProps) {
  return (
    <div className={cx('c1-pageHeader', className)} {...props}>
      <div className="c1-pageHeaderText">
        {eyebrow ? <span className="c1-eyebrow">{eyebrow}</span> : null}
        <h1 className="c1-pageTitle">{title}</h1>
        {subtitle ? <p className="c1-pageSubtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="c1-pageHeaderActions">{actions}</div> : null}
    </div>
  );
}
